import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si el cumpleaños es en pocos días?',
  a: 'Sí. El Tomo 1 incluye un cronograma de emergencia para 7 días o menos. Si el cumple es la semana que viene, este es exactamente el momento para comprarlo y aplicarlo hoy mismo.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Apenas confirmás el pago recibís el acceso de forma inmediata. Todo en PDF, listo para abrir desde el celular, tablet o computadora. Sin esperas, sin instalaciones, sin programas raros.'
}, {
  q: '¿Está adaptado a la realidad argentina?',
  a: 'Totalmente. Está diseñado pensando en nuestra economía, nuestra inflación, nuestros proveedores y la forma en que organizamos eventos en Argentina. No es una guía traducida del exterior.'
}, {
  q: '¿Funciona para cualquier tipo de cumpleaños?',
  a: 'Sí. Sea en casa, en un salón alquilado, en una plaza o en un club. El sistema se adapta a tu espacio y presupuesto. Los 12 tomos cubren todos los escenarios posibles.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días sin preguntas. Si abrís los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el reembolso y te lo devolvemos el 100%. Sin formularios, sin drama.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-ink" data-id="element-51" data-mp="11wpae3dyka67">
      <div className="mx-auto max-w-3xl px-5 pt-[0px] pb-[0px]" data-id="element-52" data-mp="11ve6m3kij2f3">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-53" data-mp="16oqu2adgh369">
          ¿ Lo que más nos preguntan ?
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-ink-2" data-id="element-54" data-mp="wy5mvyjpuqbq">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-55" data-mp="mzq3khqxklcs" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 pt-[0px] pb-[10px] text-left transition-colors hover:bg-white/[0.03]" data-id="element-56" data-mp="myoidkg7aihc">
                  <span className="pt-[3px] text-sm font-bold text-white sm:text-base" data-id="element-57" data-mp="2fxvf7v2zjnse">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-iris" data-id="element-58" data-mp="2azk31dp7x170" /> : <PlusIcon className="h-5 w-5 shrink-0 text-iris-soft" data-id="element-59" data-mp="38kpw6i0lg514" />}
                </button>
                <div className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-60" data-mp="33kliezr2loel">
                  <div className="overflow-hidden" data-id="element-61" data-mp="2unsypxpyzpb9">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-62" data-mp="1n8epj56r2kzv">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}